export default __webpack_public_path__ + "static/media/utility11.218292ec.svg";